import { useContext, useEffect } from "react"
import { useLocation } from "react-router-dom"

import { BreadcrumbContext } from "@/app/layouts/breadcrumb-context"

/** Lê o mapa de sobreposições de rótulo do breadcrumb. */
export function useBreadcrumbOverrides(): Record<string, string> {
  return useContext(BreadcrumbContext)?.overrides ?? {}
}

/**
 * Registra o título da página atual no breadcrumb. Enquanto o componente
 * estiver montado, o segmento correspondente ao caminho atual exibe `titulo`
 * em vez do valor bruto da URL.
 */
export function useBreadcrumbTitulo(titulo?: string) {
  const { pathname } = useLocation()
  const contexto = useContext(BreadcrumbContext)
  const definir = contexto?.definir
  const limpar = contexto?.limpar

  useEffect(() => {
    if (!definir || !limpar || !titulo) return
    definir(pathname, titulo)
    return () => limpar(pathname)
  }, [definir, limpar, pathname, titulo])
}
